/**
 * Checkbox — Selection indicator element
 *
 * Variants:
 *   - checked: true/false
 *   - size: sm, md
 */
import { styled, XStack } from 'tamagui'

const CheckboxFrame = styled(XStack, {
  name: 'Checkbox',
  role: 'checkbox',
  ai: 'center',
  jc: 'center',
  br: '$full',
  bw: 2,
  bc: '$borderColor',
  bg: '$backgroundCard',
  cursor: 'pointer',
  pressStyle: { opacity: 0.7, scale: 0.85 },
  hoverStyle: { opacity: 0.85 },

  variants: {
    checked: {
      true: {
        bg: '$colorPrimary',
        bc: '$colorPrimary',
      },
      false: {
        bg: '$backgroundCard',
        bc: '$borderColor',
      },
    },

    size: {
      sm: { w: 20, h: 20 },
      md: { w: 24, h: 24 },
    },
  } as const,

  defaultVariants: {
    size: 'md',
  },
})

export const Checkbox = CheckboxFrame.styleable((props, ref) => (
  <CheckboxFrame
    ref={ref}
    transition="quick"
    animateOnly={['opacity', 'transform', 'background-color', 'border-color']}
    {...props}
  />
))
